// 处理 public\assets\js\config.js

const ApiUrl = window.sysConfig.ApiUrl
const ApiToken = window.sysConfig.ApiToken
const WelcomeText = window.sysConfig.WelcomeText
const WelcomeTitle = window.sysConfig.WelcomeTitle
const VoiceConfig = window.sysConfig.VoiceConfig

export {
  ApiUrl,
  ApiToken,
  WelcomeText,
  WelcomeTitle,
  VoiceConfig
}

